module.exports = __webpack_public_path__ + "img/charging-hub-realized-proprietary.6261492a.svg";